import {GUEST_FORM_NAMES} from '@chekin/core';

enum EXTRA_FORM_NAMES {
  signature = 'signature',
  secondPhoneDetails = 'second_phone_details',
  send_copy_contract_email = 'send_copy_contract_email',
}

const IV_FIELDS = [
  'o_c_r_passed',
  'biomatch_passed',
  'biomatch_percentage',
  'guest_biomatch_doc',
  'guest_biomatch_doc_service',
  'guest_biomatch_selfie',
  'guest_biomatch_selfie_service',
  'guest_front_side_scan',
  'guest_front_side_scan_service',
  'guest_back_side_scan',
  'guest_back_side_scan_service',
  'document_front_side_scan',
  'document_back_side_scan',
  'biomatch_selfie',
  'biomatch_doc',
];

const DATE_FIELDS = [
  GUEST_FORM_NAMES.birth_date,
  GUEST_FORM_NAMES.document_issue_date,
  GUEST_FORM_NAMES.document_expiration_date,
] as const;

const AGREEMENT_CLAUSE_FIELDS = [GUEST_FORM_NAMES.agreement_clauses] as const;

const SIGNATURE_FIELDS = [GUEST_FORM_NAMES.signature];

const SELECT_FIELDS = [
  GUEST_FORM_NAMES.document_type,
  GUEST_FORM_NAMES.gender,
  GUEST_FORM_NAMES.kinship_relationship,
  GUEST_FORM_NAMES.purpose_of_stay,
  GUEST_FORM_NAMES.tax_exemption,
  GUEST_FORM_NAMES.mode_of_transport,
] as const;

const PHONE_FIELDS = [GUEST_FORM_NAMES.phone, GUEST_FORM_NAMES.second_phone] as const;

const LOCATIONS_FIELDS = [
  'nationality',
  'birth_place_country',
  'residence_country',
  'document_expedition_country',
  'next_destination_country',
  'next_destination_district',
  'next_destination_municipality',
  'citizenship',
  'arrived_from_country',
  'arrived_from_district',

  'residence_city',
  'document_expedition_city',
  'birth_place_city',
  'arrived_from_municipality',
  'next_destination_municipality',
];

const AgreementClauseKeyFormName = 'agreement_clause_';

export {
  EXTRA_FORM_NAMES,
  IV_FIELDS,
  DATE_FIELDS,
  SIGNATURE_FIELDS,
  PHONE_FIELDS,
  SELECT_FIELDS,
  LOCATIONS_FIELDS,
  AGREEMENT_CLAUSE_FIELDS,
  AgreementClauseKeyFormName,
};
